export default "__VITE_ASSET__D7fWP$rB__"